var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cash-balance-loader"},[_c('Heading',{attrs:{"level":3}},[_vm._v("Conta")]),_c('SkeletonLoader',{staticClass:"cash-balance-loader__value"},[_c('div')]),_c('SkeletonLoader',{staticClass:"cash-balance-loader__value"},[_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }